<script>
  // @ts-nocheck
  import { onMount } from 'svelte';
  import { goto } from '$app/navigation';

  import { slugify } from '$lib/utils/common';
  import { Routes } from '$lib/constants/routes';
  import { formatCurrency } from '$lib/utils/number';
  import { sanitizeHtml } from '$lib/utils/html';

  import AppCardSmall from '../AppCard/AppCardSmall.svelte';
  import Screen from '../Screen.svelte';
  import AppPreview from './AppPreview.svelte';
  import SmallAppPreview from './SmallAppPreview.svelte';

  export let apps = [];
  export let description = '';
  export let hasPaid;
  export let isOpen = false;
  export let name = '';
  export let price;

  function handleClickClose() {
    isOpen = false;

    goto(Routes.BUNDLES_LISTINGS);
  }

  onMount(() => {
    function handleListenKeyDown(event) {
      if (event.key === 'Escape' && isOpen) {
        handleClickClose();
      }
    }

    window.addEventListener('keydown', handleListenKeyDown);

    return () => {
      window.removeEventListener('keydown', handleListenKeyDown);
    };
  });
</script>

<a href="/bundles/listings/{slugify(name)}" class="ring-0 outline-none w-full">
  <div class="bg-gray-300/30 grid grid-cols-2 sm:grid-cols-2 gap-3 rounded-2xl p-4 backdrop-blur-lg">
    {#if apps.length < 4}
      {#each apps as app (app.id)}
        <AppPreview appName={app.name} bgImage={sanitizeHtml(app.image)} />
      {/each}
    {:else}
      {#each apps.slice(0, 3) as app (app.id)}
        <AppPreview appName={app.name} bgImage={sanitizeHtml(app.image)} />
      {/each}

      <div class="grid grid-cols-2 gap-1.5 rounded-2xl">
        {#each apps.slice(3, 7) as app (app.id)}
          <SmallAppPreview appName={app.name} bgImage={sanitizeHtml(app.image)} />
        {/each}
      </div>
    {/if}
  </div>

  <p class="justify-center items-center p-2 text-gray-900 text-sm font-semibold flex flex-col text-center">
    {name}

    <span class="mt-1 text-indigo-600 text-xs flex items-center">
      {#if price}
        {#if hasPaid}
          <svg class="h-3 w-3 mr-1" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M18 1.5c2.9 0 5.25 2.35 5.25 5.25v3.75a.75.75 0 01-1.5 0V6.75a3.75 3.75 0 10-7.5 0v3a3 3 0 013 3v6.75a3 3 0 01-3 3H3.75a3 3 0 01-3-3v-6.75a3 3 0 013-3h9v-3c0-2.9 2.35-5.25 5.25-5.25z"></path>
          </svg>
        {:else}
          <svg class="h-3 w-3 mr-1" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path clip-rule="evenodd" fill-rule="evenodd" d="M12 1.5a5.25 5.25 0 00-5.25 5.25v3a3 3 0 00-3 3v6.75a3 3 0 003 3h10.5a3 3 0 003-3v-6.75a3 3 0 00-3-3v-3c0-2.9-2.35-5.25-5.25-5.25zm3.75 8.25v-3a3.75 3.75 0 10-7.5 0v3h7.5z"></path>
          </svg>
        {/if}
        {formatCurrency(price)}
      {/if}
    </span>
  </p>
</a>

{#if isOpen}
  <div class="fixed top-0 left-0 w-full h-full z-20 overflow-scroll py-0 pb-10 md:py-10 bg-white/95">
    <Screen>
      <div class="flex items-start mt-4">
        <div class="flex-1">
          {#if price}
            {#if hasPaid}
              <p class="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl flex items-center">
                {name}
                <span class="inline-block ml-5 text-sm bg-indigo-600 text-white px-4 py-2 rounded-lg font-medium tracking-wide">
                  Paid
                </span>
              </p>
            {:else}
              <form method="POST">
                <input type="hidden" name="bundleSlug" value={slugify(name)}>
                <p class="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl flex flex-col items-start md:flex-row md:items-center">
                  {name}
                  <button type="submit" class="inline-block mt-5 md:mt-0 md:ml-5 text-sm bg-indigo-600 text-white px-4 py-2 rounded-lg font-medium tracking-wide whitespace-nowrap">
                    Get for {formatCurrency(price)}
                  </button>
                </p>
              </form>
            {/if}
          {:else}
            <p class="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl flex items-center">
              {name}
            </p>
          {/if}
          <p class="mt-6 text-lg leading-8 text-gray-600 max-w-4xl mb-10">{description}</p>
        </div>
        <button type="button" on:click={handleClickClose} class="flex opacity-50 hover:opacity-80 outline-none">
          <svg class="h-12 w-12" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <div class="grid grid-cols-2 md:grid-cols-5 gap-5">
        {#each apps as app (app.id)}
          <AppCardSmall
            categories={app.categories ?? []}
            creatorName={app.creator_name}
            description={app.description}
            favoritesCount={app.favorites_count}
            imageSrc={app.image}
            link="/{app.id}"
            name={app.name}
          />
        {/each}
      </div>
    </Screen>
  </div>

{/if}
